import type { OrdersFilter } from '@/api/gopos';

export function parseGoposOrdersTopbarFilters(
  searchParams: URLSearchParams,
  enabled: boolean,
): OrdersFilter {
  if (!enabled) return {};

  const filters: OrdersFilter = {};
  const venueMappingId = searchParams.get('venue_mapping_id');
  if (venueMappingId) filters.venue_mapping_id = venueMappingId;
  const dateFrom = searchParams.get('date_from');
  if (dateFrom) filters.date_from = dateFrom;
  const dateTo = searchParams.get('date_to');
  if (dateTo) filters.date_to = dateTo;
  const orderNumber = searchParams.get('order_number');
  if (orderNumber) filters.order_number = orderNumber;
  return filters;
}

export function buildGoposOrdersTopbarFilterParams(
  searchParams: URLSearchParams,
  key: keyof OrdersFilter,
  value: string | null,
): URLSearchParams {
  const params = new URLSearchParams(searchParams);
  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }
  return params;
}

export function buildGoposOrdersTopbarDateRangeParams(
  searchParams: URLSearchParams,
  from: string | undefined,
  to: string | undefined,
): URLSearchParams {
  const params = new URLSearchParams(searchParams);
  if (from) {
    params.set('date_from', from);
  } else {
    params.delete('date_from');
  }
  if (to) {
    params.set('date_to', to);
  } else {
    params.delete('date_to');
  }
  return params;
}

export function buildResetGoposOrdersTopbarParams(searchParams: URLSearchParams): URLSearchParams {
  const params = new URLSearchParams(searchParams);
  params.delete('venue_mapping_id');
  params.delete('date_from');
  params.delete('date_to');
  return params;
}
